import React from "react";

import TuneIcon from "@mui/icons-material/Tune";
import { IconButton, Stack, Typography } from "@mui/material";
import { RoleComponentGuard } from "components/guards";
import { useFormatNumericHook } from "hooks";
import { useNumberFormatSelector } from "store";

import { RoleName } from "../../../constants";

interface Props {
  title: string;
  value: string;
  onMenuClick: (anchorEl: HTMLButtonElement) => void;
}

export const Cubic: React.FC<Props> = ({ title, value, onMenuClick }) => {
  const { abbreviated, decimal } = useNumberFormatSelector();
  const formatNumeric = useFormatNumericHook();

  return (
    <Stack
      sx={{
        p: "8px 10px",
        border: "1px solid #DBE8F5",
        flexGrow: 1,
        flex: 100 / 5 + "%",
        justifyContent: "center",
        position: "relative",
        ".MuiIconButton-root": {
          opacity: 0
        },
        ":hover": {
          ".MuiIconButton-root": {
            opacity: 1
          }
        }
      }}
    >
      <Typography sx={{ textAlign: "center", fontSize: "15px", lineHeight: "20px", color: "#496682", fontWeight: 400 }}>
        {title}
      </Typography>
      <Typography sx={{ textAlign: "center", fontSize: "15px", lineHeight: "20px", color: "#071F35", fontWeight: 700 }}>
        {formatNumeric({ value, format: { abbreviated, decimal } })}
      </Typography>
      <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
        <IconButton
          onClick={(e) => onMenuClick(e.currentTarget)}
          sx={{
            position: "absolute",
            right: "2px",
            top: "2px",
            zIndex: 100,
            transition: "opacity .15s linear"
          }}
        >
          <TuneIcon sx={{ height: 20, width: 20, color: "#5d7782" }} />
        </IconButton>
      </RoleComponentGuard>
    </Stack>
  );
};
